/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * My App
 * This is an awesome app!
 * OpenAPI spec version: 1.0.0
 */

export type GetApiVendorListAccountStatus = typeof GetApiVendorListAccountStatus[keyof typeof GetApiVendorListAccountStatus] | null;


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetApiVendorListAccountStatus = {
  active: 'active',
  unconfirmed: 'unconfirmed',
  blocked: 'blocked',
} as const;
